export enum CircleBadgeColor {
  GREEN = '#43ac8b',
  YELLOW = '#e0b36a',
  GREY = '#babcbb',
}
